import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'activeUser'})
export class ActiveUserPipe implements PipeTransform {
    transform<T extends { isActive?: boolean; }>(users?: T[]): T[] | undefined {
        return users?.filter(u => u.isActive);
    }
}
